export default __webpack_public_path__ + "static/media/TAN.572c9ee0.svg";